import _ from 'lodash';
import moment from 'moment-timezone';

export function diffDeep(obj1:Object | any[], obj2:Object | any[]):boolean {
    try {
        return _.isEqual(obj1, obj2)
    } catch (e) {
        throw e;
    }
}

export function getObjectDiffs(obj1:Record<string, any>, obj2:Record<string, any>) {
    try {
        return Object.keys(obj1).reduce((result, key:string | number) => {
            if (!obj2.hasOwnProperty(key)) {
                // @ts-ignore
                result.push(key);
                // @ts-ignore
            } else if (_.isEqual(obj1[key], obj2[key])) {
                // @ts-ignore
                const resultKeyIndex = result.indexOf(key);
                result.splice(resultKeyIndex, 1);
            }
            return result;
        }, Object.keys(obj2));
    } catch (e) {
        throw (e);
    }
}
/**
 * @param startDate 'ISOstring'
 * @param finishDate 'ISOstring'
 * @returns `'OPEN' or 'SOON' or 'D-*' or '' `
 */
export function calculateDateDiff(startString: string, finishString: string) {
    try {
        const today = moment().tz('Asia/Seoul');
        const start = moment(startString).tz('Asia/Seoul');
        const finish = moment(finishString).tz('Asia/Seoul');

        if (today.isAfter(finish)) return 'CLOSED';
        if (today.isBetween(start, finish)) return 'OPEN';

        if (today.isBefore(start)) {
            // KST 날짜 기준으로 차이 계산 (시간 무시)
            const startDay = start.clone().startOf('day');
            const todayDay = today.clone().startOf('day');
            const daysDiff = startDay.diff(todayDay, 'days');

            if (daysDiff <= 7) return 'SOON';
            return 'D-' + String(daysDiff);
        }
        return '';
    } catch (e) {
        console.error(e);
        return '';
    }
}
/**
 * @param startDate 'ISOstring'
 * @param finishDate 'ISOstring'
 * @returns `'OPEN' or 'SOON' or 'D-*' or '' `
 */
export function calculateDateDiffV2(startDate: string, finishDate: string) {
    try {
        const today = moment().tz('Asia/Seoul');
        const start = moment(startDate).tz('Asia/Seoul');
        const finish = moment(finishDate).tz('Asia/Seoul');

        if (today.isAfter(finish)) return 'CLOSED';
        if (today.isBetween(start, finish)) return 'OPEN';

        if (today.isBefore(start)) {
            // KST 날짜 기준으로 차이 계산 (시간 무시)
            const startDay = start.clone().startOf('day');
            const todayDay = today.clone().startOf('day');
            const daysDiff = startDay.diff(todayDay, 'days');

            if (daysDiff <= 7) return 'SOON';
            return 'D-' + String(daysDiff);
        }
        return '';
    } catch (e) {
        console.error(e);
        return '';
    }
}

const diffs = {
    diffDeep,
    getObjectDiffs,
}

// export {
//     diffDeep,
//     getObjectDiffs,
// }

export default diffs;